import { FormControlLabel, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
export const SummarizeContainer = styled(Paper)<{ 
  optVariant?: 
  'messageForTopic' | 'heading' | 'optimization'
}>(
  ({ optVariant, theme }) => {
    switch (optVariant) {
      case 'messageForTopic':
        return {
          padding: '16px',
          border: '1px solid #e6e8eb',
          borderRadius: '4px',
          boxShadow: 'none',
        };
      case 'heading':
        return {
          paddingBottom: '8px',
          boxShadow: 'none',
          border: 'none',
          borderRadius: '0',
        };
      case 'optimization':
        return {
          border: 'none',
          borderRadius: '0',
          boxShadow: 'none',
          [theme.breakpoints.down('sm')]: {
            marginBottom: '8px',
          },
        };
      default:
        return {};
    }
  },
);
export const SummarizeFormControlLabel = styled(FormControlLabel)({
  paddingBottom: '8px',
  width: '100%',
});
